import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { schemaTemplatesDivisionMail } from '../tables';

type Arguments = {
    position?: number;
};

export const schemaTemplateResolver_ListByDivisions = z.record(
    z.object({
        entries: z.array(schemaTemplatesDivisionMail),
        name: z.string(),
    }),
);

export type SchemaTemplateResolver_ListByDivisions = z.infer<typeof schemaTemplateResolver_ListByDivisions>;

export type TemplateResolver_ListByDivisions = Resolver<Arguments, SchemaTemplateResolver_ListByDivisions>;
